import React from 'react'
import Routes from 'routes'
import { connect } from 'react-redux'
import { withApp } from 'helpers'
import { withRouter } from 'react-router-dom'
import { Animation, Page, PageIntro } from 'components/library'
import { translate } from 'translations'
import { Endtest } from 'content'

class EndtestIntroIntro extends React.Component {
  componentDidMount() {
    this.props.app.setBackground(this.props.endtest.intro.poster, this.props.endtest.intro.posterStyle)
    this.props.app.setLocation({ label: 'intro' })
  }

  handleHome = e => {
    this.props.history.push(Routes.to('home'))
  }

  handleContinue = e => {
    this.props.history.push(Routes.to('endtestTest'))
  }

  render() {
    return (
      <Page name="Intro" theme={this.props.app.theme}>
        <Animation name="slideInDown" delay={100}>
          <PageIntro
            title={this.props.endtest.intro.title}
            description={this.props.endtest.intro.description}
            continueButtonLabel={translate('card.start')}
            handleHome={this.handleHome}
            handleContinue={this.handleContinue}>
          </PageIntro>
        </Animation>
      </Page>
    )
  }
}

export default withRouter(withApp(connect(
  (state, props) => ({
    endtest: Endtest,
  }),
  (dispatch) => ({})
)(EndtestIntroIntro)))



// WEBPACK FOOTER //
// ./src/components/views/endtest/components/IntroIntro.js